<template>
  <div>
    <PageAllow controller="Shops" action="shopPsi" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearchPsiShop v-model="shopSelected" />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'PsiShops',
                    'shopPsiCurrentStockExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="shopPsiCurrentStockExports()"
              >
                {{ $t("ShopPsi.Export.currentStockExport") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearchMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                    :shopId="shop_id"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearchMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                    :shopId="shop_id"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSelect
                    ref="brand"
                    v-model="options.brand"
                    :items="material_brands"
                    :label="$t('Material.Fields.brand')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("CurrentStocks.zeroStatus.title") }}
                  </div>
                  <v-radio-group row v-model="options.inventory_flg">
                    <v-radio
                      :label="$t('CurrentStocks.zeroStatus.on')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('CurrentStocks.zeroStatus.off')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shop_stock_materials"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 均价 -->
            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money") }}{{ item.average_price | formatMoney }}
            </template>
            <!-- 商品分类 -->
            <template v-slot:item.category_name="{ item, index }">
              <span
                class="text-no-wrap"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{ item.category_name }}
              </span>
            </template>
            <!-- 商品名称 -->
            <!-- <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                {{
                  $t("Material.materialNameWithCode", [
                    item.material_code,
                    item.material_name,
                  ])
                }}
              </span>
            </template> -->
            <!-- 库存数量 -->
            <template v-slot:item.current_count="{ item }">
              <span class="text-no-wrap">
                {{ $numberFormatter.formatTwoDot(item.current_count, true)
                }}{{ item.unit }}
              </span>
            </template>
            <!-- 库存总价 -->
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                v-model="item.printBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="info"
                    class="px-2"
                    @click.stop=""
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentStocks.actions.details") }}
                    <v-icon x-small class="ps-1">
                      {{ item.printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 库存详情 -->
                  <!-- <v-list-item
                    v-if="$permission.permissionAllow('StockCurrents', 'view')"
                    :href="'/#/shop-psi/' + item.material_id"
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.stock_details") }}
                    </v-list-item-title>
                  </v-list-item> -->
                  <!-- 出入库明细 -->
                  <v-list-item
                    v-if="$permission.permissionAllow('Shops', 'shopPsiDetail')"
                    :href="
                      '/#/shop-stock-order-analyze?shop_id=' +
                      shop_id +
                      '&material_id=' +
                      item.material_id
                    "
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.in_out_details") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Shops from "@/api/shops";
import SearchPsiShop from "@/components/plugins/SearchPsiShop";
import SearchMaterials from "./plugins/SearchMaterials";
import SearchMaterialCategoriesWithDescendants from "./plugins/SearchMaterialCategoriesWithDescendants";
import SearcherSelect from "@/components/plugins/SearcherSelect";
import Materials from "@/api/materials";

const defaultOptions = {
  category_codes: [],
  material_ids: [],
  inventory_flg: 0,
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearchPsiShop,
    SearchMaterialCategoriesWithDescendants,
    SearchMaterials,
    SearcherSelect,
  },
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("shop_psi-options")
        ? sessionStorage.getItem("shop_psi-options")
        : JSON.stringify(defaultOptions)
    ),
    shopSelected: null,
    shop_id: null,
    materialCategoriesSelected: [],
    materialSelected: [],
    // material_groups: [],
    // material_origins: [],
    material_brands: [],
    // material_storage_conditions: [],
    paging: [],
    loading: false,
    shop_stock_materials: [],
    exportDialog: false,
  }),
  mounted() {
    Materials.fetchFiledSelects({
      field_names: ["brand"],//, "material_group", "origin", "brand", "storage_conditions"],
    }).then(// 暂时只用品牌查询，只做品牌的数据
      function (response) {
        if (response.data.status.isOK()) {
          // this.material_groups = response.data.material_group;
          // this.material_origins = response.data.origin;
          this.material_brands = response.data.brand;
          // this.material_storage_conditions = response.data.storage_conditions;
        }
      }.bind(this)
    );

    this.$commonUtils.loadOptions("shopPsi", ["shopSelected", "materialCategoriesSelected", "materialSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        }
        //  else this.resetSearch();
        // this.shop_id = Number(this.$route.query.shop_id);
        // this.materialSelected = Number(this.$route.query.material_id);
        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "shopSelected":
              this.shopSelected = selected.value;
              break;
            case "materialCategoriesSelected":
              this.materialCategoriesSelected = selected.value;
              break;
            case "materialSelected":
              this.materialSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.shopPsi"),
        disabled: false,
        href: "/shop-psi",
      },
      {
        text: i18n.t("Nav.shopStock"),
        disabled: true,
        href: "/shop-psi",
      },
    ],
    headers: () => [
      {
        text: i18n.t("ShopPsi.Fields.material_code"),
        align: "center",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("ShopPsi.Fields.material_name"),
        align: "center",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("ShopPsi.Fields.standard_name"),
        align: "center",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("ShopPsi.Fields.category_name"),
        align: "center",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("ShopPsi.Fields.brand"),
        align: "center",
        sortable: false,
        value: "brand",
      },
      {
        text: i18n.t("ShopPsi.Fields.average_price"),
        align: "center",
        sortable: false,
        value: "average_price",
      },
      {
        text: i18n.t("ShopPsi.Fields.current_count"),
        align: "center",
        sortable: false,
        value: "current_count",
      },
      {
        text: i18n.t("ShopPsi.Fields.total_price"),
        align: "center",
        sortable: false,
        value: "total_price",
      },
      {
        text: i18n.t("ShopPsi.Fields.action"),
        align: "center",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["settings", "stickTableCols"]),
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.shopSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getshopPsiFromAPI() {
      this.loading = true;
      Shops.shopPsi(
        Object.assign({}, this.options, { shop_id: this.shop_id })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.paging = response.data.paging;
            this.shop_stock_materials = response.data.shop_stock_materials;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    shopPsiCurrentStockExports() {
      Shops.shopPsiCurrentStockExports(Object.assign({}, this.options, { shop_id: this.shop_id }));
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        if (this.shopSelected) {
          this.getshopPsiFromAPI();
          sessionStorage.setItem(
            "shop_psi-options",
            JSON.stringify(this.options)
          );
        }
      },
    },
    shopSelected: {
      handler() {
        this.shop_id = this.shopSelected ? this.shopSelected.id : null;
        if (this.shopSelected) {
          this.getshopPsiFromAPI();
        } else {
          this.paging = [];
          this.shop_stock_materials = [];
        }
        sessionStorage.setItem(
          "shopPsi-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.code;
            })
          : [];
        sessionStorage.setItem(
          "shopPsi-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.material_id;
            })
          : [];
        sessionStorage.setItem(
          "shopPsi-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>
